module.exports = __webpack_public_path__ + "img/listNameA.a281a773.png";